import { create } from "zustand";

export const useBridgeStore = create((set) => ({
  sidebarRefresh: null,
  refreshType: "", // 'chat', 'channel', 'favorite', or 'all'
  triggerSidebarRefresh: (timestamp, type = "all") =>
    set({
      sidebarRefresh: timestamp,
      refreshType: type,
    }),
  channelHeaderRefresh: null,
  searchParticularRecord: { id: 0, name: "" },
  searchMsgText: { value: "", timestamp: 0 },
  jumpConfig: { active: false },
  globalSectionConfig: {
    openedSection: "",
    isExpanded: false,
    payload: "",
  },

  triggerChannelHeaderRefresh: (timestamp) => {
    set({ channelHeaderRefresh: timestamp });
  },

  setSearchParticularRecord: (data) => {
    set({ searchParticularRecord: data });
  },
  setSearchMsgText: (data) => {
    set({ searchMsgText: data });
  },
  setJumpConfig: (data) => {
    set({ jumpConfig: data });
  },

  headerRefresh: null,
  headerRefreshType: "", // 'rename', 'members', 'pins', 'files', or 'all'
  triggerHeaderRefresh: (timestamp, type = "all") =>
    set({
      headerRefresh: timestamp,
      headerRefreshType: type,
    }),
  setGlobalSectionConfig: (data) => {
    set((state) => ({
      globalSectionConfig: {
        ...state.globalSectionConfig,
        ...data,
      },
    }));
  },

  syncMuteConfig: {
    identifiers: "",
    status: "",
    isFavourite: "",
  },
  setSyncMuteConfig: (identifiers, status, isFavourite=false) => {
    set({ syncMuteConfig: { identifiers, status, isFavourite } });
  },
  draftRefresh: null,
  triggerDraftRefresh: (timestamp) =>
    set({
      draftRefresh: timestamp,
    }),
  // Set by "Mark as read" (sidebar or header); the open chat with this id clears its unread-reply dots
  threadsReadSignal: { id: null, at: 0 },
  triggerThreadsRead: (id) => set({ threadsReadSignal: { id, at: Date.now() } }),
  // Set when the socket reconnects; the open chat re-reads its latest messages
  socketReconnectedAt: 0,
  triggerSocketReconnected: () => set({ socketReconnectedAt: Date.now() }),
}));
